import React from 'react';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';

import * as classes from './ScoringTab.module.css';

const ScoringTab = ({
    ...props
}) => {

    const MenuProps = {
        disablePortal:      true,
        getContentAnchorEl: () => null,
        PaperProps:         {
            style: {
                maxHeight: 500
            },
        },
    };

    return (
        <div className={classes.EditorColContainer} style={{ overflowY: 'auto' }}>
            <div className={classes.PanelTitle}>
                Scoring
            </div>
            <FormControlLabel
                style={{paddingBottom: '1rem'}}
                control={
                    <Checkbox
                        style={{ marginBottom: '0.4rem', marginLeft: '0.4rem', transform: 'scale(1.5)', color: 'black' }}
                    />
                }
                label={<Typography className={classes.Label}>Use Formula-Based custom scoring</Typography>}
            />
            <div>
                <FormControl
                    variant="outlined"
                    size="small"
                    className={classes.InputWrapper}
                >
                    <InputLabel
                        htmlFor="templateName"
                        classes={{
                            error:   classes.error,
                            focused: classes.labelFocused,
                            root:    classes.label
                        }}
                    >
                        Formula Output Data Type
                    </InputLabel>
                    <Select
                        value={0}
                        id="type"
                        MenuProps={MenuProps}
                        name="type"
                        classes={{
                            root: classes.input
                        }}
                    >
                        <MenuItem
                            key={0}
                            value={0}
                        >
                            Analog
                        </MenuItem>
                    </Select>
                </FormControl>
                <FormControl
                    size="small"
                    className={classes.userInputWrapper}
                    style={{ width: 150, marginLeft: 15 }}
                >
                    <TextField
                        size="small"
                        variant="outlined"
                        id="name"
                        name="name"
                        type="text"
                        value={'0'}
                        label={'Score Value'}
                        InputLabelProps={{
                            classes: {
                                error:   classes.error,
                                focused: classes.labelFocused,
                                root:    classes.label
                            }
                        }}
                        inputProps={{ maxLength: 250 }}
                        InputProps={{
                            classes: {
                                error:     classes.cssErrorUnderline,
                                underline: classes.cssUnderline,
                                root:      classes.input
                            }
                        }}
                        FormHelperTextProps={{
                            classes: {
                                error: classes.error
                            }
                        }}
                    />
                </FormControl>
                <FormControl
                    size="small"
                    className={classes.userInputWrapper}
                    style={{ width: 150, marginLeft: 15 }}
                >
                    <TextField
                        size="small"
                        variant="outlined"
                        id="name"
                        name="name"
                        type="text"
                        value={'100'}
                        label={'Score Value'}
                        InputLabelProps={{
                            classes: {
                                error:   classes.error,
                                focused: classes.labelFocused,
                                root:    classes.label
                            }
                        }}
                        inputProps={{ maxLength: 250 }}
                        InputProps={{
                            classes: {
                                error:     classes.cssErrorUnderline,
                                underline: classes.cssUnderline,
                                root:      classes.input
                            }
                        }}
                        FormHelperTextProps={{
                            classes: {
                                error: classes.error
                            }
                        }}
                    />
                </FormControl>
                <FormControl>
                    <FormControlLabel
                        control={
                            <Checkbox
                                style={{ marginLeft: '1.8rem', transform: 'scale(1.5)', color: 'black' }}
                            />
                        }
                        label={<Typography className={classes.Label}>Use custom weighting (1-100)</Typography>}
                    />
                </FormControl>
                <FormControl
                    size="small"
                    className={classes.userInputWrapper}
                    style={{ width: 150 }}
                >
                    <TextField
                        size="small"
                        variant="outlined"
                        id="name"
                        name="name"
                        type="text"
                        value={''}
                        label={'Custom Weight'}
                        InputLabelProps={{
                            classes: {
                                error:   classes.error,
                                focused: classes.labelFocused,
                                root:    classes.label
                            }
                        }}
                        inputProps={{ maxLength: 250 }}
                        InputProps={{
                            classes: {
                                error:     classes.cssErrorUnderline,
                                underline: classes.cssUnderline,
                                root:      classes.input
                            }
                        }}
                        FormHelperTextProps={{
                            classes: {
                                error: classes.error
                            }
                        }}
                    />
                </FormControl>
            </div>
        </div>
    );
};

export default ScoringTab;
